export const defaultType = "1_iva_form_300";

export const defaultParamsReport = () => {
    return {
        type: defaultType,
        date: []
    };
};

export default {
    ag_grid: {
        selectedTheme: "ag-theme-balham"
    },
    paramsReport: defaultParamsReport(),
    taxTypes: [
        {
            id: 1,
            key: "1_iva_form_300",
            label: "Impuesto declaración de IVA - Formulario 300"
        },
        {
            id: 2,
            key: "2_ret_fuente_form_350",
            label:
                "Impuesto declaración retención en la fuente - Formulario 350"
        },
        {
            id: 3,
            key: "3_renta_form_110",
            label: "Impuesto declaración de Renta - Formulario 110"
        },
        {
            id: 4,
            key: "4_ica_declaration",
            label: "Impuesto declaración ICA"
        }
    ],
    rowData: [],
    configData: {
        "1_iva_form_300": [],
        "2_ret_fuente_form_350": [],
        "3_renta_form_110": [],
        "4_ica_declaration": []
    },
    currentRowData: {
        "1_iva_form_300": [],
        "2_ret_fuente_form_350": [],
        "3_renta_form_110": [],
        "4_ica_declaration": []
    },
    indexesToSkip: {
        "1_iva_form_300": [41, 43, 55, 57, 67, 77, 81, 82, 83, 86, 88, 89, 93],
        "2_ret_fuente_form_350": [],
        "3_renta_form_110": [44, 46, 58, 61, 67, 72, 75, 79, 83, 84, 87, 91, 93, 111, 113],
        "4_ica_declaration": [11, 16, 18, 20, 24, 27]
    },
    lastKey: ''
};



// WEBPACK FOOTER //
// ./src/modules/tax-liquidator/state.js